import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTE_SLUGS } from '@/i18n';

export const SITE = 'https://inbuonacompagnia.it';

export const Seo = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  const lang = parts[0] === 'en' ? 'en' : 'it';

  // Blog post pages manage their own SEO (dynamic title/description)
  if (parts[1] === 'blog' && parts[2]) return null;

  const slug = parts[1] || '';
  const key = Object.keys(ROUTE_SLUGS).find((k) => ROUTE_SLUGS[k][lang] === slug) || 'home';
  const title = t(`seo.${key}.title`);
  const desc = t(`seo.${key}.desc`);
  const itPath = ROUTE_SLUGS[key].it ? `/it/${ROUTE_SLUGS[key].it}` : '/it';
  const enPath = ROUTE_SLUGS[key].en ? `/en/${ROUTE_SLUGS[key].en}` : '/en';
  const canonical = SITE + (lang === 'en' ? enPath : itPath);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="it" href={SITE + itPath} />
      <link rel="alternate" hrefLang="en" href={SITE + enPath} />
      <link rel="alternate" hrefLang="x-default" href={SITE + itPath} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === 'en' ? 'en_US' : 'it_IT'} />
    </Helmet>
  );
};
